export const ROUTES = [
  {
    label: 'manage-notifications.title',
    link: '',
  },
];
